import { CloudUpload } from "@mui/icons-material";
import {
    Avatar,
    Button,
    FormControl,
    Grid,
    InputLabel,
    Select,
    TextField,
    Typography,
} from "@mui/material";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import LoadingAnimation from "../../Components/LottieAnimation/LoadingAnimation";
import { PrimaryButton } from "../../Layouts/ButtonsControlled";
import { FormHeading } from "../../Layouts/Heading";
import {
    GetSingleInstaller,
    reset,
    UpdateInstaller,
} from "../../Redux/InstallerSlice/InstallerSlice";
import uploadImage from "../../Assets/images/uploadImage.png";
import { toast } from "react-toastify";

const EditInstaller = () => {
    const { installer_id } = useParams();
    const dispatch = useDispatch();

    const { installer, isSuccess, isError, isLodaing, message } = useSelector(
        (state) => state.installer
    );
    const Installer_info = installer?.data[0];
    console.log(Installer_info);

    const [FormSubmit, setformSubmit] = useState(false);
    const formik = useFormik({
        initialValues: {
            name: "",
            email: "",
            company_name: "",
            phone: "",
            business_fax: "",
            address: "",
            date_of_origination: "",
            logo_url: "",
            apcr_path: "",
            agreement_path: "",
            nda_path: "",
        },
        onSubmit: async (values) => {
            const Form_Data = new FormData();

            Form_Data.append("installer_id", installer_id);
            Form_Data.append("name", values.name);
            Form_Data.append("email", values.email);
            Form_Data.append("company_name", values.company_name);
            Form_Data.append("phone", values.phone);
            Form_Data.append("business_fax", values.business_fax);
            Form_Data.append("address", values.address);
            Form_Data.append("date_of_origination", values.date_of_origination);
            Form_Data.append("logo_url", values.logo_url);
            Form_Data.append("apcr_path", values.apcr_path);
            Form_Data.append("agreement_path", values.agreement_path);
            Form_Data.append("nda_path", values.nda_path);
            setformSubmit(true);
            await dispatch(
                UpdateInstaller({ data: Form_Data, installer_id: installer_id })
            );
            await dispatch(reset());
        },
    });

    useEffect(() => {
        const GetSingleInstallerMethod = async () => {
            await dispatch(GetSingleInstaller(installer_id));
            await dispatch(reset());
        };
        GetSingleInstallerMethod();
    }, []);

    const handleChangeLogo = (e) => {
        formik.values.logo_url = e.currentTarget.files[0];
    };
    const handleChangeAPCR = (e) => {
        formik.values.apcr_path = e.currentTarget.files[0];
    };
    const handleChangeAgreement = (e) => {
        formik.values.agreement_path = e.currentTarget.files[0];
    };
    const handleChangeNDA = (e) => {
        formik.values.nda_path = e.currentTarget.files[0];
    };

    useEffect(() => {
        if (Installer_info) {
            formik.values.name = Installer_info?.name || "";
            formik.values.email = Installer_info?.email || "";
            // formik.values.password = Installer_info?.password || "";
            // formik.values.password_confirmation =
            //     Installer_info?.password_confirmation || "";
            formik.values.company_name = Installer_info?.company_name || "";
            formik.values.phone = Installer_info?.phone || "";
            formik.values.business_fax = Installer_info?.business_fax || "";
            formik.values.address = Installer_info?.address || "";
            formik.values.date_of_origination =
                Installer_info?.date_of_origination || "";
            // formik.values.logo_url = Installer_info?.logo_url || "";
            // formik.values.apcr_path = Installer_info?.apcr_path || "";
            // formik.values.agreement_path = Installer_info?.agreement_path || "";
            // formik.values.nda_path = Installer_info?.nda_path || "";
        }
    }, [Installer_info]);

    useEffect(() => {
        if (isSuccess && FormSubmit) {
            setformSubmit(true);
            toast.success("Updated Successfully");
        } else {
            setformSubmit(false);
        }
    }, [isSuccess]);

    return (
        <>
            {isLodaing && <LoadingAnimation />}
            {!isLodaing && (
                <FormContainer>
                    <form onSubmit={formik.handleSubmit}>
                        <Grid container columns={12} spacing={3}>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="name"
                                    name="name"
                                    label="Name"
                                    value={formik.values.name}
                                    onChange={formik.handleChange}
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="email"
                                    name="email"
                                    label="Email"
                                    value={formik.values.email}
                                    onChange={formik.handleChange}
                                />
                            </Grid>
                            {/* <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    type="password"
                                    id="password"
                                    name="password"
                                    label="Password"
                                    value={formik.values.password}
                                    onChange={formik.handleChange}
                                />
                            </Grid> */}

                            {/* <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="password_confirmation"
                                    type="password"
                                    name="password_confirmation"
                                    label="Password Confirmation"
                                    value={formik.values.password_confirmation}
                                    onChange={formik.handleChange}
                                />
                            </Grid> */}
                        </Grid>
                        <FormHeading> Company Info </FormHeading>

                        <Grid container columns={12} spacing={3}>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="company_name"
                                    name="company_name"
                                    label="Company Name"
                                    value={formik.values.company_name}
                                    onChange={formik.handleChange}
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="phone"
                                    name="phone"
                                    label="Phone"
                                    value={formik.values.phone}
                                    onChange={formik.handleChange}
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="business_fax"
                                    name="business_fax"
                                    label="Bussiness Fax"
                                    value={formik.values.business_fax}
                                    onChange={formik.handleChange}
                                />
                            </Grid>

                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="address"
                                    name="address"
                                    label="Address"
                                    value={formik.values.address}
                                    onChange={formik.handleChange}
                                />
                            </Grid>

                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="date_of_origination"
                                    name="date_of_origination"
                                    label="Date"
                                    type="date"
                                    value={formik.values.date_of_origination}
                                    onChange={formik.handleChange}
                                />
                            </Grid>

                            <Grid
                                item
                                mb={1}
                                xs={12}
                                md={6}
                                className="file-upload-input"
                            >
                                <Typography variant="label" color="gray">
                                    APCR File
                                </Typography>
                                <FileUploadStyle>
                                    <input
                                        type="file"
                                        name="apcr_path"
                                        id="apcr_path"
                                        onChange={(e) => handleChangeAPCR(e)}
                                    />
                                </FileUploadStyle>
                            </Grid>

                            <Grid
                                item
                                mb={1}
                                xs={12}
                                md={6}
                                className="file-upload-input"
                            >
                                <Typography variant="label" color="gray">
                                    Agreement File
                                </Typography>
                                <FileUploadStyle>
                                    <input
                                        type="file"
                                        name="agreement_path"
                                        id="agreement_path"
                                        onChange={(e) =>
                                            handleChangeAgreement(e)
                                        }
                                    />
                                </FileUploadStyle>
                            </Grid>

                            <Grid
                                item
                                mb={1}
                                xs={12}
                                md={6}
                                className="file-upload-input"
                            >
                                <Typography variant="label" color="gray">
                                    NDA File
                                </Typography>
                                <FileUploadStyle>
                                    <input
                                        type="file"
                                        name="nda_path"
                                        id="nda_path"
                                        onChange={(e) => handleChangeNDA(e)}
                                    />
                                </FileUploadStyle>
                            </Grid>

                            <Grid item mb={1} xs={12} md={6}>
                                <Typography
                                    variant="lable"
                                    id="logo_url"
                                    label="logo"
                                    align="justify"
                                >
                                    <Avatar
                                        alt="Upload logo"
                                        src={uploadImage}
                                        sx={{
                                            width: "7em",
                                            height: "7em",
                                            margin: "auto",
                                        }}
                                    />
                                    <Typography
                                        variant="h6"
                                        sx={{
                                            fontWeight: "700",
                                            color: "#888",
                                        }}
                                        align="center"
                                    >
                                        Logo picture
                                    </Typography>
                                    <Typography
                                        sx={{ color: "#888" }}
                                        variant="h6"
                                        align="center"
                                    >
                                        Any assets used in projects will live
                                        here.
                                        <br></br> Start creating by uploading
                                        your files.
                                    </Typography>
                                </Typography>
                                <Button
                                    mt={3}
                                    mr={2}
                                    ml={2}
                                    fullWidth
                                    variant="contained"
                                    component="label"
                                >
                                    <CloudUpload />
                                    <span mr={2} ml={2}>
                                        Upload
                                    </span>
                                    <input
                                        hidden
                                        accept="image/*"
                                        type="file"
                                        name="logo_url"
                                        id="logo_url"
                                        onChange={(e) => handleChangeLogo(e)}
                                    />
                                </Button>
                            </Grid>
                        </Grid>
                        <PrimaryButton fullWidth type="submit">
                            {isLodaing ? "loading ... " : "Update"}
                        </PrimaryButton>
                    </form>
                </FormContainer>
            )}
        </>
    );
};

const FormContainer = styled.div`
    padding: 1rem;
`;

const FileUploadStyle = styled.div`
    input {
        cursor: pointer;
        font: inherit;
        letter-spacing: inherit;
        color: currentcolor;
        padding: 4px 0px 5px;
        border: 0px;
        box-sizing: content-box;
        background: none;
        height: 1.4375em;
        margin: 0px;
        -webkit-tap-highlight-color: transparent;
        display: block;
        min-width: 0px;
        width: 100%;
        animation-name: mui-auto-fill-cancel;
        animation-duration: 10ms;
        border-bottom: 3px solid gray;
    }
`;
export default EditInstaller;
